import React from 'react';
import { ShieldCheck, Zap, BadgeCheck, Lock } from 'lucide-react';

const ITEMS = [
  { icon: ShieldCheck, title: 'Secure & Reliable', sub: 'Your data is protected' },
  { icon: Zap, title: 'Blazing Fast Execution', sub: 'Low latency, high performance' },
  { icon: BadgeCheck, title: 'SEBI Registered', sub: 'INZ000174634' },
  { icon: Lock, title: 'Your Capital, Your Control', sub: 'You stay in control always' },
];

/**
 * Bottom reassurance band on the landing page — four value props matching the
 * Zebu marketing mockup.
 */
const TrustBand: React.FC = () => {
  return (
    <section className="bg-zebu-50/60 dark:bg-gray-900 py-10">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {ITEMS.map((item) => (
            <div key={item.title} className="flex items-center gap-3">
              <div className="h-10 w-10 rounded-lg bg-white dark:bg-gray-800 ring-1 ring-zebu-100 dark:ring-gray-700 flex items-center justify-center shrink-0">
                <item.icon className="h-5 w-5 text-zebu-600 dark:text-zebu-400" />
              </div>
              <div>
                <p className="text-sm font-semibold text-gray-900 dark:text-white leading-tight">{item.title}</p>
                <p className="text-xs text-gray-500 dark:text-gray-400">{item.sub}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustBand;
